import React from 'react';

import classNames from 'classnames/bind';
import styles from './CenterLocation.module.scss';

const cx = classNames.bind(styles);

function CenterLocation({ locationData = '', onChange = () => console.warn('onChange is not defined.'), current = '' }) {
	const handleOnChange = (location) => {
		onChange(location);
	};
	const items = locationData.map((loc, index) => {
		const key = `key${index}`;
		return (
			<li
				key={key}
				className={cx({ on: loc.value === current })}
			>
				<button
					type="button"
					className={cx('btn_location')}
					onClick={() => handleOnChange(loc.value)}
				>
					<span className={cx('tit_location')}>{loc.tab}</span>
				</button>
			</li>
		);
	});
	return (
		<div className={cx('wrap_location')}>
			<h4 className={cx('blind')}>지역 선택</h4>
			<ul className={cx('list_location')}>{items}</ul>
		</div>
	);
}

export default CenterLocation;
